/* @flow */

import * as React from 'react';
import { useMemo } from 'react';

import Localizer from '../../helpers/localization';
import { PictoExternal } from '../pictos/Element';

type ExternalLinkPropType = {
  +textKey: string,
  +url: string,
};

const ExternalLink = ({ textKey, url }: ExternalLinkPropType): React.Node => {
  const text = useMemo(() => Localizer.localize(textKey), [textKey]);

  return (
    <a href={url} rel='noopener noreferrer' target='_blank'>
      {text}
      <PictoExternal aria-hidden />
    </a>
  );
};

export default ExternalLink;
